import { Divider } from "@chakra-ui/layout";
import { FC } from 'react';
import { AdminLevelShare, CollaborationLevelShare, ViewLevelShare } from "./levels";
import { ModalWithFooter } from "components";
import { useTeamById, usePackShareTokens } from "lib/hooks";
import { useActivePackContext } from "lib/context";

type Props = {
  onClose: () => void;
  isOpen: boolean;
}

export const SharePackModal: FC<Props> = ({ onClose, isOpen }) => {
  const { activePack } = useActivePackContext();
  const { data: team } = useTeamById(isOpen && activePack?.id ? activePack.id : null);
  const { data: shareTokens } = usePackShareTokens(isOpen && activePack?.id ? activePack.id : null);

  return (
    <ModalWithFooter title="Share this pack" isOpen={isOpen} onClose={onClose} size={"lg"}>
      <ViewLevelShare shareTokens={shareTokens} team={team} />
      <Divider mt="20px" mb="20px" />
      <CollaborationLevelShare shareTokens={shareTokens} team={team} />
      <Divider mt="20px" mb="20px" />
      <AdminLevelShare shareTokens={shareTokens} team={team} />
    </ModalWithFooter>
  )
}
